import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var DeviceLogsActionType;
(function (DeviceLogsActionType) {
    DeviceLogsActionType["SET_DEVICE_MESSAGE_LOGS"] = "set device message logs";
    DeviceLogsActionType["SET_DEVICE_HTTP_LOGS"] = "set device http logs";
    DeviceLogsActionType["SET_DEVICE_LOG_REQUESTS"] = "set device log requests";
})(DeviceLogsActionType || (DeviceLogsActionType = {}));
/**
 * Create an action to add log entries to the state
 */
export const setDeviceMessageLogs = (deviceId, entries, searchParams) => {
    return {
        type: DeviceLogsActionType.SET_DEVICE_MESSAGE_LOGS,
        deviceId,
        entries,
        searchParams,
    };
};
/**
 * Create an action to add log entries to the state
 */
export const setDeviceHttpLogs = (deviceId, entries, searchParams) => {
    return {
        type: DeviceLogsActionType.SET_DEVICE_HTTP_LOGS,
        deviceId,
        entries,
        searchParams,
    };
};
/**
 * Create an action to add log entries to the state
 */
export const setDeviceLogRequests = (deviceId, entries, searchParams) => {
    return {
        type: DeviceLogsActionType.SET_DEVICE_LOG_REQUESTS,
        deviceId,
        entries,
        searchParams,
    };
};
/**
 * Get Messages logs for a specific device
 * @param deviceId - The device we want to get the message log for
 * @param begin - The first date of the log entries we want to get
 * @param end - The last date of the log entries we want to get
 * @param limit - OPTIONAL - The maximum number of entries we want to get
 */
export const fetchDeviceMessageLogEntries = (deviceId, begin, end, limit) => {
    return async (dataDispatch) => {
        const logs = await RitzAPI.getInstance().getDeviceMessageLogEntries(deviceId, begin, end, limit);
        await dataDispatch(setDeviceMessageLogs(deviceId, logs, searchParamsToString({
            begin, end, limit,
        })));
    };
};
/**
 * Get HTTP requests logs for a specific device
 * @param deviceId - The device we want to get the http request logs for
 * @param begin - The first date of the log entries we want to get
 * @param end - The last date of the log entries we want to get
 * @param limit - OPTIONAL - The maximum number of entries we want to get
 */
export const fetchDeviceHttpLogEntries = (deviceId, begin, end, limit) => {
    return async (dataDispatch) => {
        const logs = await RitzAPI.getInstance().getDeviceHttpLogEntries(deviceId, begin, end, limit);
        await dataDispatch(setDeviceHttpLogs(deviceId, logs, searchParamsToString({
            begin, end, limit,
        })));
    };
};
/**
 * Get all log requests for a specific device with the specified filters
 * @param deviceId - The device we want to get the log request for
 * @param sortBy - The name and sort order of the field we want to sort the result by. e.g. 'status:desc'
 * @param statuses - The commas separated list of status we want to filter by e.g. 'success,cancelled,failure'
 * @param pageNumber - The page number (used for paging)
 * @param pageSize - The maximum number of entries we want (used for paging)
 */
export const fetchDeviceLogRequestEntries = (deviceId, sortBy, statuses, pageNumber, pageSize) => {
    return async (dataDispatch) => {
        const requests = await RitzAPI.getInstance().getDeviceLogRequestEntries(deviceId, sortBy, statuses, pageNumber !== undefined && pageSize !== undefined ? pageNumber * pageSize : undefined, pageSize);
        await dataDispatch(setDeviceLogRequests(deviceId, requests, searchParamsToString({
            sortBy, statuses, pageNumber, pageSize,
        })));
    };
};
/**
 * Create a new log request for a specific device
 * @param deviceId - The device we want to create the log request for
 * @param startDate - OPTIONAL - The start date of the log file
 * @param endDate - OPTIONAL - The end date of the log file
 * @param prefixes - OPTIONAL - The list of prefixes of the log file names
 */
export const createDeviceLogRequest = (deviceId, startDate, endDate, prefixes) => {
    return async () => {
        await RitzAPI.getInstance().createDeviceLogRequest(deviceId, startDate, endDate, prefixes);
        // TODO may be clear or reload log requests
    };
};
/**
 * Cancel a specific log request for a device.
 * @param deviceId - The device id of the device the log request belonged to
 * @param requestId - The id of the log request we want to cancel
 */
export const cancelDeviceLogRequest = (deviceId, requestId) => {
    return async () => {
        await RitzAPI.getInstance().cancelDeviceLogRequest(deviceId, requestId);
        // TODO may be clear or reload log requests
    };
};
